import React from 'react';
import useAddAdminUser from './hooks/useAddAdminUser';
import { ADD_ADMIN_TOAST_ID } from './hooks/useAddAdminUserAPI';
import { RolesSection, CheckEmail } from '../../components/AddAdminUser';
import {
  ADD_ADMIN,
  ADD_ADMIN_DESCRIPTION,
  ADMIN_EXIST_MESSAGE,
} from '../../utils/constants';
import GeneralInformation from '../../components/EditAdminUser/GeneralInformation';
import { ROUTE_ADMIN } from '../../components/Routing/routeHelpers';
import { ConfirmModal } from '../../utils/ConfirmModal';
import Form from '../../components/Form/Form';

const AddAdminUser = () => {
  const {
    adminId,
    isAdminExist,
    isLoading,
    messageText,
    adminDetails,
    adminDetails: {
      role: selectedRole = '',
      email,
      tenant,
      organisations: selectedOrganisations,
    },
    isFormInValid,
    modal: { isOpen, setIsOpen },
    onCheckEmail,
    onAdd,
    onCancel,
    onInputChange,
  } = useAddAdminUser();

  const isDisabled = isAdminExist || messageText !== '';

  return (
    <React.Fragment>
      <Form
        onCancel={onCancel}
        onSubmit={onAdd}
        submitButtonText={ADD_ADMIN}
        headerTitle={ADD_ADMIN}
        headerDescription={ADD_ADMIN_DESCRIPTION}
        isDisabled={isFormInValid}
      >
        <CheckEmail
          disabled={isLoading}
          onCheckEmail={onCheckEmail}
          onChange={onInputChange}
          email={email}
          messageText={messageText}
        />
        <GeneralInformation
          admin={adminDetails}
          onChange={onInputChange}
          shouldEmailDisabled
          disabled={isDisabled}
        />
        <RolesSection
          selectedTenant={tenant}
          selectedOrganisations={selectedOrganisations}
          selectedRole={selectedRole}
          onChange={onInputChange as any}
          disabled={isDisabled}
        />
      </Form>
      <div id={ADD_ADMIN_TOAST_ID} />
      {isAdminExist && (
        <ConfirmModal
          modalVisibility={setIsOpen}
          open={isOpen}
          heading="Edit?"
          message={ADMIN_EXIST_MESSAGE}
          navigation={{
            path: ROUTE_ADMIN.edit.replace(':adminId', adminId!),
            context: null,
          }}
        />
      )}
    </React.Fragment>
  );
};

export default AddAdminUser;
